import React, { useCallback } from 'react';
import size from 'lodash/size';

import {
  ChangeProductsFiltersFunc,
  FetchProductsFilterFields,
  FetchProductsFilters
} from '../../../../../../../../products/productsTypes';

import { Translate } from '../../../../../../../../../helpers/Translate';
import { PureIconButtonHelper } from '../../../../../../../../../helpers/buttons/PureIconButtonHelper';

import { groupByBaseColors } from '../../../../../../../utils/groupByBaseColors';

import { categoriesKeys } from '../../../../../../../../../locales/keys';

import { IconsEnum } from '../../../../../../../../../assets/icons/types';

interface ProductsColorsFilterBadgeProps {
  changeProductsFilters: ChangeProductsFiltersFunc;
  productsFilters: FetchProductsFilters;
}

function ProductsColorsFilterBadge({
  changeProductsFilters,
  productsFilters
}: ProductsColorsFilterBadgeProps) {
  const colors = groupByBaseColors(
    productsFilters[FetchProductsFilterFields.AI_MAIN_COLOR_TAGS]?.in || []
  );

  const handleRemoveFilter = useCallback(() => {
    changeProductsFilters({}, [FetchProductsFilterFields.AI_MAIN_COLOR_TAGS]);
  }, [changeProductsFilters]);

  const valueCount = size(colors);

  if (!valueCount) {
    return null;
  }

  return (
    <div className="relative bg-blue-500 bg-opacity-20 dark:text-gray-200 inline-flex items-center m-0.5 px-3 py-1.5 rounded-md text-gray-800 text-sm ">
      <div>
        <Translate id={categoriesKeys.colors.plural} />: &nbsp;
        {valueCount}
      </div>

      <PureIconButtonHelper
        className="flex-shrink-0 ml-1 -my-1 -mr-2 h-6 w-6 rounded inline-flex items-center justify-center text-gray-800 dark:text-gray-200 hover:bg-gray-500 hover:bg-opacity-20 hover:text-gray-700 dark:hover:bg-opacity-20 dark:hover:bg-white dark:hover:text-white"
        dataGa={`${FetchProductsFilterFields.AI_MAIN_COLOR_TAGS}-clear`}
        icon={IconsEnum.X}
        iconClassName="h-3.5 w-3.5"
        onClick={handleRemoveFilter}
      />
    </div>
  );
}

export default ProductsColorsFilterBadge;
